import css from 'styled-jsx/css';

const staticStyles = css.global`
  .NewContactsTable {
    position: relative;
    min-width: 0;
    width: 100%;

    .NewBaseTable {
      min-width: 100%;
    }

    .NewBaseTable__wrapper {
      border: 1px solid #e5e9ef;
      border-radius: 8px;
      scrollbar-color: #b9c4d2 #eef2f6;
    }

    .NewBaseTable__col {
      box-sizing: border-box;
      padding: 12px;
      line-height: 1.4;
    }

    .NewBaseTable__head__col {
      height: 48px;
      background: #f7f9fb;
      color: #64748b;
      position: sticky !important;
      top: 0;
      z-index: 6 !important;
      box-shadow: inset 0 -1px 0 #e5e9ef;
    }

    .NewBaseTable__row {
      height: 56px;
      border-color: #e5e9ef;
    }

    .NewBaseTable__body .NewBaseTable__row:hover .NewBaseTable__col {
      background: #f7fbfe;
    }

    .NewBaseTable__actions {
      align-items: center;
      margin: 0 0 12px;
    }

    .NewBaseTable__actions-reload {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border: 1px solid #e5e9ef;
      border-radius: 6px;
      background: #fff;
    }

    .checkboxWrapper {
      display: flex;
      justify-content: center;
      padding: 6px 0;
      cursor: pointer;
    }

    .CheckBox {
      appearance: auto;
      margin: 0;
      opacity: 1;
      cursor: pointer;
      accent-color: #0aa1e2;
      width: 18px !important;
      height: 18px !important;
    }

    .NewFullNameCell {
      align-items: center;
      padding: 0;
      gap: 8px;
    }

    .NewFullNameCell__FullName {
      min-width: 0;
      cursor: pointer;
      color: #0b4d72;
      overflow-wrap: break-word !important;
      word-break: normal !important;
      hyphens: none;
    }

    .NewFullNameCell__favorite {
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 26px;
      height: 26px;
      border-radius: 4px;
    }

    .NewFullNameCell__ManagerIcon {
      flex-shrink: 0;
    }

    .MoneyCell__inner {
      font-variant-numeric: tabular-nums;
      white-space: nowrap !important;
    }

    .Tags {
      top: 0;
      gap: 6px;
      max-width: 100%;
    }

    .NewBaseTable__body .NewBaseTable__col {
      white-space: normal;
      vertical-align: middle;
      overflow-wrap: break-word !important;
      word-break: normal !important;
      hyphens: none;
    }

    &__totals {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      margin: 12px 0 16px;
      align-items: stretch;
    }

    &__total {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px 16px;
      padding: 12px 16px;
      border: 1px solid #e5e9ef;
      border-radius: 8px;
      color: #64748b;
      font-size: 13px;
      background: #fff !important;
      border-color: #d8e0ea !important;
    }

    .BOPaginationTable__pagination {
      margin-top: 16px;
    }

    @media (max-width: 767px) {
      &__total {
        flex: 1 1 140px;
      }
      .BOPaginationTable__pagination__nav {
        gap: 12px;
      }
    }

    &__status {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &__status-dot {
      width: 8px;
      height: 8px;
      flex-shrink: 0;
      border-radius: 50%;
    }

    :is(button, input, select, a):focus-visible,
    .NewBaseTable :is(button, input, select, a):focus-visible,
    .NewBaseTable__visibility :is(button, input):focus-visible,
    .BOPaginationTable__pagination :is(button, input):focus-visible {
      outline: 2px solid #0aa1e2 !important;
      outline-offset: 2px !important;
      border-radius: 4px;
    }

    .CheckBox:focus-visible {
      outline: 2px solid #0aa1e2 !important;
      outline-offset: 1px !important;
    }

    .NewBaseTable__draghandle svg {
      color: #94a3b8 !important;
    }

    .NewBaseTable__draghandle:hover svg {
      color: #475569 !important;
    }

    .NewBaseTable__head__col-arrow {
      color: #94a3b8 !important;
    }

    .NewBaseTable__head__col-arrow:hover {
      color: #475569 !important;
    }

    .NewBaseTable__head__col:has(.NewBaseTable__head__col-arrow--up),
    .NewBaseTable__head__col:has(.NewBaseTable__head__col-arrow--down) {
      background: #eaf4fb !important;
      box-shadow: inset 0 -2px 0 #087db5;
    }

    .NewBaseTable__head__col:has(.NewBaseTable__head__col-arrow--up) .NewBaseTable__head__col-label span,
    & .NewBaseTable__head__col:has(.NewBaseTable__head__col-arrow--down) .NewBaseTable__head__col-label span {
      color: #087db5 !important;
      font-weight: 600 !important;
    }

    .NewBaseTable__head__col-label span {
      font-size: 13px !important;
      color: #51607a !important;
    }

    .NewBaseTable__actions-reload svg path {
      fill: #51607a !important;
    }

    .NewBaseTable__actions-reload:hover svg path {
      fill: #087db5 !important;
    }

    .NewBaseTable__actions-reload:hover {
      border-color: #0aa1e2 !important;
    }

    .NewBaseTable__body .NewBaseTable__row:has(.CheckBox:checked) .NewBaseTable__col {
      background: #eaf4fb !important;
    }

    .NewBaseTable__body .NewBaseTable__row:has(.CheckBox:checked) .NewBaseTable__col:first-child {
      box-shadow: inset 3px 0 0 #087db5;
    }

    .NewFullNameCell__FullName:hover {
      color: #0aa1e2;
      text-decoration: underline;
      text-underline-offset: 2px;
    }

    .NewFullNameCell__favorite:hover {
      background: #f1f5f9;
    }

    .TagItem {
      color: #0a2b33 !important;
      border: 1px solid rgba(10, 43, 51, 0.14);
      font-weight: 500;
      border-radius: 6px;
    }

    .TagItem:hover,
    .TagItem:focus {
      padding: 3px 13.5px !important;
    }

    .TagItem .TagItem__delete,
    .TagItem:hover .TagItem__delete,
    .TagItem:focus .TagItem__delete {
      display: none !important;
    }

    &__total:first-child {
      box-shadow: inset 3px 0 0 #16a34a;
    }

    &__total:nth-child(2) {
      box-shadow: inset 3px 0 0 #dc2626;
    }

    &__total:nth-child(3) {
      box-shadow: inset 3px 0 0 #087db5;
    }

    .NewBaseTable__head__col:hover .NewBaseTable__resizer div {
      background: #b9c4d2;
    }

    .NewBaseTable__body td[colspan] {
      position: relative;
      z-index: 4;
      background: #fff;
      text-align: left !important;
      padding: 48px 24px !important;
    }

    .NewBaseTable__body td[colspan] > span {
      position: sticky;
      left: 24px;
      display: inline-block;
      color: #5b6b7f;
      font-size: 15px;
    }

    .NewBaseTable:has(.NewBaseTable__body td[colspan]) .NewBaseTable__resizer {
      height: 100% !important;
    }

    .NewBaseTable__loader {
      height: 220px !important;
      border: 1px solid #e5e9ef;
      border-radius: 8px;
      background: #f7f9fb !important;
    }

    .NewBaseTable__visibility__dropdown-menu {
      max-height: #{'min(60vh, 460px)'} !important;
      padding: 14px 16px !important;
      gap: 12px !important;
    }

    .NewBaseTable__visibility__checkbox-label {
      text-transform: none !important;
    }

    .NewBaseTable__visibility__toggle-button-checkbox {
      color: #51607a !important;
    }

    .NewBaseTable__visibility__toggle-button {
      min-height: 36px;
    }

    .NewBaseTable__visibility__toggle-button:hover {
      border-color: #0aa1e2;
    }

    .NewBaseTable__head__row > .NewBaseTable__head__col:first-child {
      position: sticky !important;
      left: 0;
      z-index: 8 !important;
      background: #f7f9fb !important;
    }

    .NewBaseTable__body .NewBaseTable__row > .NewBaseTable__col:first-child {
      position: sticky !important;
      left: 0;
      z-index: 5;
      background: #fff;
    }

    .NewBaseTable__head__row > .NewBaseTable__head__col:nth-child(2) {
      position: sticky !important;
      left: calc(var(--first-visible-column-size, 80) * 1px);
      z-index: 8 !important;
      box-shadow: inset 0 -1px 0 #e5e9ef, inset -1px 0 0 #e5e9ef, 8px 0 10px -10px rgba(15, 23, 42, 0.28);
      background: #f7f9fb !important;
    }

    .NewBaseTable__body .NewBaseTable__row > .NewBaseTable__col:nth-child(2) {
      position: sticky !important;
      left: calc(var(--first-visible-column-size, 80) * 1px);
      z-index: 5;
      box-shadow: inset -1px 0 0 #e5e9ef, 8px 0 10px -10px rgba(15, 23, 42, 0.28);
      background: #fff;
    }

    .NewBaseTable__body .NewBaseTable__row:hover:not(:has(.CheckBox:checked)) > .NewBaseTable__col:first-child,
    .NewBaseTable__body .NewBaseTable__row:hover:not(:has(.CheckBox:checked)) > .NewBaseTable__col:nth-child(2) {
      background: #f7fbfe !important;
    }

    .NewBaseTable__wrapper::-webkit-scrollbar {
      height: 12px;
    }

    .NewBaseTable__wrapper::-webkit-scrollbar-track {
      background: #eef2f6;
      border-radius: 0 0 8px 8px;
    }

    .NewBaseTable__wrapper::-webkit-scrollbar-thumb {
      background: #b9c4d2;
      border: 3px solid #eef2f6;
      border-radius: 8px;
    }

    .NewBaseTable__wrapper::-webkit-scrollbar-thumb:hover {
      background: #8e9cae;
    }

    .NewBaseTable__head__row > .NewBaseTable__head__col.NewBaseTable__head__col-dragging,
    .NewBaseTable__body .NewBaseTable__col-dragging {
      z-index: 10 !important;
    }
  }
`;

export { staticStyles };
